var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MainBackButton --global-clickable",on:{"click":function($event){return _vm.$emit('request-exit')}}},[_c('svgicon',{attrs:{"icon":"arrow-left"}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('back')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }